import { CurrencyField, WorkTimeField } from "@tm/components"
import { useCustomRepairTimesDefaults } from "@tm/data/basket"
import { useLocalization } from "@tm/localization"
import Decimal from "decimal.js-light"
import { useMemo } from "react"
import { Controller, useFormContext } from "react-hook-form"
import { errorHandling } from "@tm/utils"
import { FormValue } from "./FormValue"

export function HourlyRateFields() {
    const { translateText, formatNumber } = useLocalization()

    const { control, watch } = useFormContext()

    const { customRepairTimesDefaults } = useCustomRepairTimesDefaults()
    const { defaultCurrencyCode } = customRepairTimesDefaults || {}

    const customHourlyRate = Number(watch("customHourlyRate") ?? 0)
    const workTime = Number(watch("workTime") ?? 0)

    const sumPrice = useMemo(() => new Decimal(customHourlyRate ?? 0).mul(new Decimal(workTime ?? 0)).toNumber(), [customHourlyRate, workTime])

    return (
        <>
            <Controller
                control={control}
                name="customHourlyRate"
                render={({ field, fieldState }) => (
                    <CurrencyField
                        required
                        label={`${translateText(63)} ${defaultCurrencyCode}`}
                        size="extralarge"
                        sx={{ width: "150px" }}
                        {...field}
                        {...errorHandling(fieldState)}
                    />
                )}
            />
            <Controller
                control={control}
                name="workTime"
                render={({ field, fieldState }) => (
                    <WorkTimeField
                        required
                        label={translateText(84)}
                        size="extralarge"
                        sx={{ width: "150px" }}
                        {...field}
                        {...errorHandling(fieldState)}
                    />
                )}
            />

            <FormValue label={`${translateText(57)} ${defaultCurrencyCode}`} value={formatNumber(sumPrice, 2)} />
        </>
    )
}
